/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Name_PlaceholderInputs */

const th_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อรายการแข่งขัน`)
};

const en_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event name`)
};

const ja_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会名`)
};

const zh_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事名称`)
};

const es_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del evento`)
};

const pt_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do evento`)
};

const id_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama acara`)
};

const fr_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l’événement`)
};

const tl_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan ng event`)
};

const vi_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên sự kiện`)
};

const ko_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 이름`)
};

const de_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Events`)
};

const ru_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название события`)
};

const tr_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik adı`)
};

const it_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dell'evento`)
};

const pl_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa wydarzenia`)
};

const uk_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва події`)
};

const hi_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन का नाम`)
};

const ar_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم الفعالية`)
};

const ms_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama acara`)
};

const bn_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজনের নাম`)
};

const zh_tw2_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事名稱`)
};

const zh_hk2_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事名稱`)
};

const ur_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ کا نام`)
};

const fa_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام رویداد`)
};

const sw_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina la tukio`)
};

const nl_event_name_placeholder = /** @type {(inputs: Event_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van het evenement`)
};

/**
* | output |
* | --- |
* | "Event name" |
*
* @param {Event_Name_PlaceholderInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_name_placeholder = /** @type {((inputs?: Event_Name_PlaceholderInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Name_PlaceholderInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_name_placeholder(inputs)
	if (locale === "ja") return ja_event_name_placeholder(inputs)
	if (locale === "zh") return zh_event_name_placeholder(inputs)
	if (locale === "es") return es_event_name_placeholder(inputs)
	if (locale === "pt") return pt_event_name_placeholder(inputs)
	if (locale === "id") return id_event_name_placeholder(inputs)
	if (locale === "fr") return fr_event_name_placeholder(inputs)
	if (locale === "tl") return tl_event_name_placeholder(inputs)
	if (locale === "vi") return vi_event_name_placeholder(inputs)
	if (locale === "ko") return ko_event_name_placeholder(inputs)
	if (locale === "de") return de_event_name_placeholder(inputs)
	if (locale === "ru") return ru_event_name_placeholder(inputs)
	if (locale === "tr") return tr_event_name_placeholder(inputs)
	if (locale === "it") return it_event_name_placeholder(inputs)
	if (locale === "pl") return pl_event_name_placeholder(inputs)
	if (locale === "uk") return uk_event_name_placeholder(inputs)
	if (locale === "hi") return hi_event_name_placeholder(inputs)
	if (locale === "ar") return ar_event_name_placeholder(inputs)
	if (locale === "ms") return ms_event_name_placeholder(inputs)
	if (locale === "bn") return bn_event_name_placeholder(inputs)
	if (locale === "zh-TW") return zh_tw2_event_name_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_event_name_placeholder(inputs)
	if (locale === "ur") return ur_event_name_placeholder(inputs)
	if (locale === "fa") return fa_event_name_placeholder(inputs)
	if (locale === "sw") return sw_event_name_placeholder(inputs)
	if (locale === "nl") return nl_event_name_placeholder(inputs)
	return en_event_name_placeholder(inputs)
});